import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LibroPage from "../pages/libro/page";
import PoliticasPage from "../pages/politicas/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/libro",
    element: <LibroPage />,
  },
  {
    path: "/politicas",
    element: <PoliticasPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
